import requests from '../../../../redux/reducer/requests';
import { useDispatch } from 'react-redux';

export default function usePrizesCallbacks() {
  const dispatch = useDispatch();

  return {
    getShopPrizes: () => dispatch(requests.thunks.getShopPrizes()),
  };
}
